export default {
  LOCATION_TIMES: {
    MOBILE: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description:
          'Sorry, there was an issue fetching the location times. Pull down to refresh and try again.'
      }
    },
    WEB: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description: 'Sorry, there was an issue fetching the location times.'
      }
    },
    NO_DATA: {
      message: 'There are no time slots for the selected location.'
    }
  },
  LOCK_APPOINTMENT: {
    ERROR: {
      severity: 'error' as 'error',
      title: 'Lock Appointment Error',
      description:
        'Uh oh. Someone else just picked this time slot. Please select another time slot.'
    }
  },
  EXPIRE_TIME_IN_MINUTES: 10
};
